import axios from 'axios'

const API_PATH = 'admins/fast_sell/payments'

const FastSellPaymentApi = {
  /**
   * See list of FastSell Payment`
   * @param {number} fastSellProductId id of a FastSell::Product that will own FastSell::Payment
   * @param {object} params filter params
   * @return {array} list of `Fast Sell Payment`
   */
  index: async ({ params }) => {
    const response = axios.get(API_PATH, { params })
    return response
  },
  /**
   * See details of a FastSell Payment`
   * @param {number} fastSellPaymentId id of a FastSell::Payment
   * @return {object} `Fast Sell Payment`
   */
  show: async (fastSellPaymentId) => {
    const path     = `${API_PATH}/${fastSellPaymentId}`
    const response = axios.get(path)
    return response
  },
  /**
   * Update a FastSell Payment`
   * @param {object} values formik values for update params
   * @return {object} `Fast Sell Payment`
   */
  update: async ({ values }) => {
    const params = {
      fast_sell_payment: {
        id                       : values.id,
        fast_sell_product_id     : values.fast_sell_product_id,
        amount                   : values.amount,
        transferred_at           : new Date(values.transferred_at),
        credit_bank_name         : values.credit_bank_name,
        credit_bank_branch       : values.credit_bank_branch,
        credit_bank_account_name : values.credit_bank_account_name,
        credit_bank_account_no   : values.credit_bank_account_no,
        payment_status           : values.payment_status,
        debit_bank               : values.debit_bank
      }
    }

    const response = axios.put(API_PATH, params)
    return response
  },
  /**
   * Complete the payment of FastSell`
   * @param {object} formData formData when completing Fast Sell Payment
   * @return {object} `Fast Sell Payment`
   */
  complete: async ({ formData }) => {
    const path     = `${API_PATH}/complete`
    const response = axios.patch(path, formData)
    return response
  }
}

export default FastSellPaymentApi
